import {Container} from "aurelia-framework";
import {Client} from "../../api/client";
import EditorContent from "./editor-content";

let client;

function getClient() {
    if (!client) {
        client = Container.instance.get(Client);
    }

    return client;
}

export const queryMedia = query => getClient().get('media-database/media-item?embeds[]=file').then(r => r.items.map(i => ({
    id: i.id,
    media_type: 'image',
    mime_type: i.mimeType,
    title: i.title,
    caption: i.title,
    source_url: i.file.previewUrl ? i.file.previewUrl.replace("$width", "1500").replace("$height", "-") : i.file.downloadUrl
})));

const media = new Map();

export const createMedia = (file, title) => {

    if (!EditorContent.reference) {
        throw new Error('Bitte erst speichern, bevor Medien hinzugefügt werden können');
    }

    const data = new FormData();

    data.append('reference[id]', EditorContent.reference.id);
    data.append('reference[modelId]', EditorContent.reference.modelId);
    data.append('file', file);
    data.append('filename', file.name);
    data.append('mimeType', file.type);

    return getClient().post('file/upload-from-editor', data).then(({data}) => {
        media.set(data.id, {
            media_type: file.type.split('/')[0],
            mime_type: file.type,
            title: {raw: data.title || ''},
            caption: {raw: data.title || ''},
            id: data.id,
            date: data.createdAt,
            date_gmt: data.createdAt,
            source_url: data.file.previewUrl ? data.file.previewUrl.replace("$width", "1500").replace("$height", "-") : data.file.downloadUrl
        });

        return media.get(data.id);
    });
};

export const editMedia = (query, data) => {

    let payload = {
        x: data.x,
        y: data.y,
        width: data.width,
        height: data.height,
        url: data.src,
        reference: {
            id: EditorContent.reference.id,
            modelId: EditorContent.reference.modelId
        }
    };

    return getClient().post('file/edit-from-editor/'+query.id, payload).then(({data}) => {

        media.set(data.id, {
            media_type: 'image',
            mime_type: data.file.mimeType,
            title: {raw: data.title || ''},
            caption: {raw: data.title || ''},
            id: data.id,
            date: data.createdAt,
            date_gmt: data.createdAt,
            source_url: data.file.previewUrl ? data.file.previewUrl.replace("$width", "1500").replace("$height", "-") : data.file.downloadUrl
        });

        return media.get(data.id);
    });
};

export const getMedia = id => media.get(id);
